import fetch from '@giro/shared-utils/fetch.util';

export default async function getApiFeesService() {
  return fetch(`fees`, {
    method: 'GET',
    ms: 'PDV',
    auth: true,
  });
}
